import { render, staticRenderFns } from "./optional-notifiable-users.vue?vue&type=template&id=da0fc33c"
import script from "./optional-notifiable-users.ts?vue&type=script&lang=ts&external"
export * from "./optional-notifiable-users.ts?vue&type=script&lang=ts&external"
import style0 from "./optional-notifiable-users.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0fc33c')) {
      api.createRecord('da0fc33c', component.options)
    } else {
      api.reload('da0fc33c', component.options)
    }
    module.hot.accept("./optional-notifiable-users.vue?vue&type=template&id=da0fc33c", function () {
      api.rerender('da0fc33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/optional-notifiable-users/optional-notifiable-users.vue"
export default component.exports